package com.bikompanion.ui.composables

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import org.maplibre.compose.expressions.dsl.const
import org.maplibre.compose.expressions.value.ProjectionType
import org.maplibre.compose.map.MapState
import org.maplibre.compose.map.StyleLoadState
import org.maplibre.compose.style.Projection
import org.maplibre.compose.util.ExperimentalMaplibreComposeApi

@OptIn(ExperimentalMaplibreComposeApi::class)
@Composable
internal actual fun configureMapProjection(mapState: MapState) {
    val loadState = mapState.style.loadState
    LaunchedEffect(mapState, loadState) {
        if (loadState == StyleLoadState.Ready) {
            mapState.style.projection.set(Projection(type = const(ProjectionType.Globe)))
        }
    }
}
